import { render, staticRenderFns } from "./SipServerCreate.vue?vue&type=template&id=a8c49f9c&"
import script from "./SipServerCreate.vue?vue&type=script&lang=js&"
export * from "./SipServerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports